import apiService from '@/services/apiService';

const actions = {
  getPPOBTransactionWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('ppob/transaction/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPPOBTransactionExport({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('ppob/transaction/find-without-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default actions;